import React from "react";

/** Uber-style suggestion: primary title + secondary address line. */
const PlaceSuggestionLabel = ({ suggestion }) => {
  const main =
    suggestion?.structured_formatting?.main_text ||
    suggestion?.description ||
    "";
  const secondary = suggestion?.structured_formatting?.secondary_text || "";

  return (
    <>
      <p className="autocomplete-suggestion-title">{main}</p>
      {secondary ? (
        <span className="autocomplete-suggestion-subtitle">{secondary}</span>
      ) : null}
    </>
  );
};

export default PlaceSuggestionLabel;
